// src/utils/apiHelpers.js
import { toast } from 'react-toastify';

/**
 * Wraps an async API call, handles errors, and displays toast notifications.
 * @param {Function} apiFn - The async API function to call.
 * @param  {...any} args - Arguments to pass to the API function.
 * @returns {Promise<any|null>} - Returns the API result or null if error.
 */
export async function safeApiCall(apiFn, ...args) {
  try {
    const result = await apiFn(...args);
    return result;
  } catch (error) {    
    toast.error(
      error?.response?.data?.message || error.message || error.error || 'Something went wrong'
    );
    return null;
  }
}
